<template>
    <slot name="buttonContent" :openModal="open" :closeModal="close" />

    <Modal
        @open="open"
        @close="close"

        @on-enter="onModalEnter"
        @on-after-enter="onModalAfterEnter"

        v-model="showModalRef"

        :container-classes="modalContainerClasses"
        :modal-container-class="modalContainerClass"
    >

        <template #header :openModal="open" :closeModal="close">
            <slot name="header" />
        </template>

        <template #body>
            <slot name="body" :openModal="open" :closeModal="close" />
        </template>

        <template v-if="$slots.footer" #footer>
            <slot name="footer" :openModal="open" :closeModal="close" />
        </template>
    </Modal>

</template>

<script setup>
/**
 * Può essere utilizzato per visualizzare un contenuto qualsiasi che se cliccato mostra un modal.
 */
import Modal from './Modal.vue'
import { ref, reactive, onMounted } from "vue"

const props            = defineProps({

    modalContainerClasses       : {
        type    : [ Array, Object, String ],
        default : []
    },

    modalContainerClass : {
        type    : [ Array, String ],
        default : 'modal-container'
    }

})

const showModalRef     = ref(false);
const emit             = defineEmits([
    'open',
    'close',

    'onModalEnter',
    'onModalAfterEnter'
])

const onModalEnter            = (el, done) => {
    emit('onModalEnter', el, done)
}

const onModalAfterEnter       = (el) => {
    emit('onModalAfterEnter', el)
}

const open              = () => {
    console.log("Open modal");

    emit('open');

    showModalRef.value = true
}

const close             = () => {

    emit('close');

    showModalRef.value = false
}

defineExpose({ open, close, isOpen : showModalRef });

</script>
